export const SEND_GLOBAL_MESSAGE = 'SEND_GLOBAL_MESSAGE';
export const SHOW_GLOBAL_MESSAGE = 'SHOW_GLOBAL_MESSAGE';
export const CLEAR_GLOBAL_MESSAGE = 'CLEAR_GLOBAL_MESSAGE';
